import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import {Validators, FormBuilder, ReactiveFormsModule} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {AdminService} from '../../shared/services/admin.service';
import {Router} from '@angular/router';
import { DailyDollarRateService } from 'src/app/shared/services/dailydollarrate.service';
import {HttpResponse} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, switchMap, tap} from 'rxjs/operators';
import {AutocompleteService} from '../../shared/services/autocomplete.service';



@Component({
    selector: 'app-dollar-rate-modal',
    templateUrl: './dollar-rate-modal.component.html',
    styleUrls: ['./dollar-rate-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReactiveFormsModule]
})
export class DollarRateModalComponent {
  
  @Output() refreshRates = new EventEmitter<void>();

  passwordType: string = 'password';
  passwordShown: boolean = false;
  icon: string = 'fa fa-eye-slash';
  form;
  status;
  response;
  responseTwo;
  searching = false;
  searchFailed = false;
  results: any;
  clicked: boolean = false;
  details;

  
  
  constructor(fb: FormBuilder, private dailyDollarRateService: DailyDollarRateService, private adminService: AdminService,
              private toastrService: ToastrService, private router: Router,  private autocompleteService: AutocompleteService) {
    this.form = fb.group({
      rate: ['', Validators.required],
    });
  }



  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.autocompleteService.searchCountry(term)
          .pipe(
            tap(results => {this.searchFailed = false; this.results = results; }),
            catchError(() => {
              this.searchFailed = true;  this.form.invalid = true;
              return of([]);
            }))
      ),
      tap(() => this.searching = false)
    )
  searchState = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.autocompleteService.searchState(term, this.form.value.country_id)
          .pipe(
            tap(results => {this.searchFailed = false; this.results = results; }),
            catchError(() => {
              this.searchFailed = true;  this.form.invalid = true;
              return of([]);
            }))
      ),
      tap(() => this.searching = false)
    )

  addNewRate() {
    this.adminService.getDetails().subscribe(
      data => {
        this.details = data[0];
       
           const dataToSubmit = {
    rate: Number(this.form.value.rate),
    uploaded_by: this.details.id
  }

  this.clicked = true;
    this.dailyDollarRateService.addNewRate(dataToSubmit).subscribe(
      data => {
        this.response = data;
        // this.responseTwo = responseArray[1];
        this.clicked = false;
        if (this.response.status) {
          this.toastrService.success(this.response.message);
          this.closeModal();
          this.refreshRates.emit(); 
        } else {
          this.toastrService.error(this.response.message);
        }
      },
      (error: HttpResponse<any>) => {
         this.toastrService.error(error.statusText);
        //  console.log(error);
         this.clicked = false;
      }
    );

     this.form.reset()

      });

 
  }
  closeModal() {
 this.form.reset()
    const modalClose: HTMLElement = document.getElementById('closeModal') as HTMLElement;
    modalClose.click();
  }
  get rate() {
    return this.form.get('rate');
  }

}


